import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthSessionService } from '@mavles/user';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  private router = inject(Router);
  private authSession = inject(AuthSessionService);

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (!this.authSession.getToken()) {
      return this.router.parseUrl('/home');
    }
    return true;
  }
}

export const authGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authSession = inject(AuthSessionService);
  if (!authSession.getToken()) {
    return router.parseUrl('/home');
  }
  return true;
};


